import React from 'react';
import authRoles from '../../../auth/authRoles';
import Reports from './Reports';
import AttendanceReports from './Attendance/AttendanceReports';
import ActivityReports from './Activity/ActivityReports';
import Staff from './Staff';
import Age from './Age';
import EnrolledStudents from './EnrolledStudents/EnrolledStudentsReports';
import RoomCheck from './RoomCheck';
import RoomRatio from './RoomRatio';
import Allergy from './Allergy';
import Medication from './Medication';
import Contacts from './Contacts/ContactsReports';
import SubscriptionReport from './Subscription/SubscriptionReport';
import Meal from './Meal';
import ImmunizationReport from './ImmunizationReport';
import DueOverDueReport from './DueOverDueReport';
import DownloadReports from './DownloadReports';
import RoyaltyReports from './Royalty/RoyaltyReports';

const ReportsConfig = {
	reports: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/reports',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Reports />
				</React.Suspense>
			),
		},
		{
			path: '/reports-checkin',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AttendanceReports />
				</React.Suspense>
			),
		},
		{
			path: '/reports-royalties',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoyaltyReports />
				</React.Suspense>
			),
		},
		{
			path: '/reports-activity',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ActivityReports />
				</React.Suspense>
			),
		},
		{
			path: '/reports-staff',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Staff />
				</React.Suspense>
			),
		},
		{
			path: '/reports-age',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Age />
				</React.Suspense>
			),
		},
		{
			path: '/reports-enrolledStudent',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EnrolledStudents />
				</React.Suspense>
			),
		},
		{
			path: '/RoomCheck',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoomCheck />
				</React.Suspense>
			),
		},
		{
			path: '/reports-roomRatio',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoomRatio />
				</React.Suspense>
			),
		},
		{
			path: '/reports-allergy',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Allergy />
				</React.Suspense>
			),
		},
		{
			path: '/reports-medication',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Medication />
				</React.Suspense>
			),
		},
		{
			path: '/reports-contact',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Contacts />
				</React.Suspense>
			),
		},
		{
			path: '/reports-subscription',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SubscriptionReport />
				</React.Suspense>
			),
		},
		{
			path: '/reports-meal',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Meal />
				</React.Suspense>
			),
		},
		{
			path: '/reports-immunization',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ImmunizationReport />
				</React.Suspense>
			),
		},
		{
			path: '/reports-due-overdue',
			element: (
				<React.Suspense fallback={<>...</>}>
					<DueOverDueReport />
				</React.Suspense>
			),
		},
		{
			path: '/reports-download',
			element: (
				<React.Suspense fallback={<>...</>}>
					<DownloadReports />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default ReportsConfig;
